import { useTheme } from "@/lib/ThemeContext";

export default function StyledPanel({ title, color, children, className = "" }) {
  const { tokens: t, styleType } = useTheme();
  const isGame = styleType === "game";
  const isPro = styleType === "professional";

  if (isGame) {
    return (
      <div className={`crt-frame ${className}`}>
        <div className="px-3 py-1.5" style={{ background: t.bgTertiary, borderBottom: `1px solid ${color}20` }}>
          <span className="font-retro text-[9px] tracking-wider crt-glow" style={{ color }}>{title}</span>
        </div>
        <div className="crt-screen crt-scanlines p-3 relative" style={{ backgroundColor: t.bgCard }}>
          <div className="relative z-10">{children}</div>
        </div>
      </div>
    );
  }

  return (
    <div className={`overflow-hidden ${className}`}
      style={{
        borderRadius: isPro ? `${t.borderRadius || 8}px` : "6px",
        border: `1px solid ${t.borderColor}`,
        boxShadow: isPro ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
      }}>
      <div className="px-3 py-2" style={{ background: t.bgTertiary, borderBottom: `1px solid ${t.borderColor}` }}>
        <span className="text-xs font-semibold tracking-wide" style={{ color, fontFamily: t.fontHeading }}>{title}</span>
      </div>
      <div className="p-3" style={{ backgroundColor: t.bgCard }}>
        {children}
      </div>
    </div>
  );
}

export function StyledTooltip({ active, payload, label, tokens: t, styleType }) {
  if (!active || !payload?.length) return null;
  const isGame = styleType === "game";

  if (isGame) {
    return (
      <div className="crt-frame p-0">
        <div className="crt-screen px-2 py-1.5" style={{ backgroundColor: t.bgCard }}>
          <p className="font-retro text-[9px] crt-glow" style={{ color: t.accent }}>{label}</p>
          {payload.map((p) => (
            <p key={p.name} className="font-retro-body text-[11px] mt-0.5" style={{ color: p.color }}>{p.name}: {p.value}</p>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-lg px-3 py-2" style={{ backgroundColor: t.bgCard, border: `1px solid ${t.borderColor}`, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
      <p className="text-xs font-semibold mb-0.5" style={{ color: t.accent }}>{label}</p>
      {payload.map((p) => (
        <p key={p.name} className="text-[11px] mt-0.5" style={{ color: p.color }}>{p.name}: {p.value}</p>
      ))}
    </div>
  );
}
